import script from "./AccountPasswordComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountPasswordComponent.vue?vue&type=script&setup=true&lang=js"

import "./AccountPasswordComponent.vue?vue&type=style&index=0&id=5c3a80f7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c3a80f7"]])

export default __exports__